import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getProducts, Product } from '../../lib/shopify';
import { useCartStore } from '../../store/useCartStore';

export const ProductList = () => {
  const [products, setProducts] = useState<Product[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const addItem = useCartStore((state) => state.addItem);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const data = await getProducts();
        setProducts(data);
      } catch (err) {
        setError('Failed to load products');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  if (loading) return <div>Loading products...</div>;
  if (error) return <div className="error">{error}</div>;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 p-6">
      {products.map((product) => {
        const image = product.images.edges[0]?.node;
        const variant = product.variants.edges[0]?.node;
        
        return (
          <div key={product.id} className="border rounded-lg overflow-hidden shadow-lg">
            {image && (
              <img
                src={image.url}
                alt={image.altText || product.title}
                className="w-full h-48 object-cover"
              />
            )}
            <div className="p-4">
              <h2 className="text-xl font-semibold mb-2">{product.title}</h2>
              <p className="text-gray-600 mb-4">
                {product.priceRange.minVariantPrice.amount} {product.priceRange.minVariantPrice.currencyCode}
              </p>
              <div className="flex justify-between items-center">
                <Link
                  to={`/shop/${product.handle}`}
                  className="text-blue-600 hover:text-blue-800 pointer-events-auto relative z-10"
                >
                  View Details
                </Link>
                <button
                  onClick={() => {
                    if (variant) {
                      addItem({
                        id: product.id,
                        variantId: variant.id,
                        title: product.title,
                        price: variant.price.amount,
                        image: image?.url,
                      });
                    }
                  }}
                  className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
                >
                  Add to Cart
                </button>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}; 